<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="premium-page-header mb-5 text-center">
                    <h1 class="ultimate-3d-title">{{ inputData?.TitleEn || 'Document' }}</h1>
                    <div class="premium-header-divider mx-auto mt-3"></div>
                </div>

                <div class="document-viewer-card" *ngIf="urlSafe; else noData">
                    <div class="document-header d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center" style="font-size: 16px; color: #0f4c3a; font-weight: 600;">
                            <i class="fa-solid fa-file-pdf fs-4 me-3" style="color: #dc3545;"></i>
                            Document Viewer
                        </div>
                        <a [href]="inputData?.ShowAttachments?.[0]?.FilePath || '#'" download class="btn btn-sm btn-success rounded-pill px-4">
                            <i class="fa-solid fa-download me-2"></i> Download
                        </a>
                    </div>
                    <iframe class="viewport"
                        width="100%"
                        frameBorder="0"
                        [src]="urlSafe"></iframe>
                </div>
                
                <ng-template #noData>
                    <div class="ultimate-3d-card p-5 text-center mx-auto" style="max-width: 400px; border-radius: 24px; background: rgba(255, 255, 255, 0.85); box-shadow: 0 15px 35px rgba(13, 139, 84, 0.08);">
                        <i class="fa-regular fa-folder-open" style="font-size: 48px; color: #cbd5e1; margin-bottom: 20px;"></i>
                        <h3 style="color: #64748b; font-weight: 600; margin: 0;">No Document Found</h3>
                    </div>
                </ng-template>

            </div>
        </div>
    </div>
</section>